module.exports = __webpack_public_path__ + "img/edge_activites_grands_evenements.7ac1128f.svg";